import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ChartPerformancePeriod } from 'src/app/models/enums';
import {
  Chart,
  Plugin
} from 'chart.js';

import 'chartjs-adapter-moment';
import 'chartjs-plugin-annotation';
const moment = require('moment');

const shadowPlugin: Plugin = {
  id: 'customShadow',
  afterDraw: (chart) => {
    const ctx = chart.ctx;
    ctx.save();
    ctx.shadowColor = '#2D31A6';
    ctx.shadowBlur = 10;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 4;
    chart.getDatasetMeta(0).controller.draw();
    ctx.restore();
  }
};

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, OnChanges {

  chartPeriod = ChartPerformancePeriod;

  lineChart: any;
  allowedChartTypes = ['line', 'bar', 'pie', 'doughnut']
  displayedYvalues: string[] = [];

  @Input() yValues: string[] = [];
  @Input() xValues: number[] = [];

  @Input() yTitle!: string;
  @Input() xTitle!: string;
  @Input() type!: any;
  @Input() chartId!: string;
  @Input() dateRangeOptions: string[] = [];
  @Input() selectedChartPeriod!: string;
  @Input() timeUnit: string = '';

  @Output() dateRangeChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }


  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.GraphXyChanged();
  }


  private InitializeGraph() {
    const data = {
      labels: this.yValues,
      datasets: [{
        data: this.xValues,
        borderColor: '#52559e',
        borderWidth: 2,
        fill: false,
        tension: 0.3,
        pointRadius: 0
      }],
    };
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'time',
          time: {
            unit: this.timeUnit, // You can specify the time unit (e.g., 'day', 'month', 'year', etc.)
          },
          ticks: {
            callback: (value: any, index: any, values: any) => {
              if (value === values[0].value) {
                return moment.unix(value / 1000).format("YYYY");
              }
              if (value === values[values.length - 1].value) {
                return moment.unix(value / 1000).format("YYYY");
              }
              return;
            },
            display: true,
            maxTicksLimit: 2,
            maxRotation: 0,
          },
          title: {
            display: true,
            text: this.xTitle,
          },
          grid: {
            display: false
          }
        },
        y: {
          ticks: {
            stepSize: function (context: any) {
              // var min = Math.min(...context.chart.data.datasets[0].data);
              var max = Math.max(...context.chart.data.datasets[0].data);
              return Math.ceil(max * 0.4);
              // var difference = max - min;
              // return Math.ceil(difference / 2);
            },
            callback: (value: any, index: any, values: any) => {
              // if (index == 0 || index == values.length - 1) {
              if (value >= 1000000) {
                return Math.floor(value / 1000000) + '.' + (value % 1000000).toString().substring(0, 1) + 'M';
              }
              if (value >= 1000) {
                return Math.floor(value / 1000) + 'k'; // Display in thousands
              }
              return value; // Display original value
              // }
            },
            font: {

            }
          },
          title: {
            display: true,
            text: this.yTitle
          }
        }
      },
      plugins: {
        tooltip: {
          enabled: true,
          intersect: false,
        }
      },
      interaction: {
        intersect: false
      }

    };
    const ctx = document.getElementById(this.chartId) as HTMLCanvasElement;
    let chartStatus = Chart.getChart(this.chartId); // <canvas> id
    if (chartStatus != undefined) {
      chartStatus.destroy();
    }


    this.lineChart = new Chart(ctx, {
      type: this.type,
      data: data,
      options: options,
      plugins: [shadowPlugin]
    });


  }

  private GraphXyChanged() {
    if (this.xValues.length < 1 || this.yValues.length < 1)
      return;
    this.InitializeGraph();
  }


  ChangeGraphDateRange(period: string) {
    this.selectedChartPeriod = period;
    this.timeUnit = period.toLowerCase();
    this.dateRangeChanged.emit(period.replace(/\s/g, "").toLowerCase());
  }
}
